<template>
  <div class="sub-menu" :class="{ 'sub-menu--display': display }" v-hover="{ cb: hover, args: [BRAND_PRIMARY_DARKEST] }">
    <div class="sub-menu__title" @click="toggleSubmenu">
      <p>{{ name }}</p>
      <Icon name="down-arrow" :size="10" :color="iconColor" />
    </div>
    <ul class="sub-menu__items">
      <SubMenuItem v-for="(value, key) in elements[0]" :key="key" :href="value" icon="right-arrow">{{ key }}</SubMenuItem>
    </ul>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { Link } from '@inertiajs/inertia-vue';
import Icon from '@/lego/components/icons/Icon.vue';
import SubMenuItem from '@/lego/components/menus/SubMenuItem.vue';
import { onMinWidth } from '@/lego/utils/window/screen';

const BRAND_PRIMARY_DARKEST = '#C88F00';

export default {
  components: {
    Link,
    Icon,
    SubMenuItem,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
  },
  setup() {
    var display = ref(false);
    var iconColor = ref('black');

    function toggleSubmenu() {
      display.value = !display.value;
    }
    function hover(el, color) {
      iconColor.value = color ?? 'black';
    }

    onMinWidth(996, function() {
      display.value = false;
    });

    return {
      display,
      iconColor,
      toggleSubmenu,
      hover,
      BRAND_PRIMARY_DARKEST,
    };
  },
};
</script>

<style lang="postcss" scoped>
.sub-menu {
  &__title {
    @apply uppercase flex items-center justify-between gap-nano hover:text-brand-primary-darkest lg:px-xxxs lg:py-xs;

    .menu__item:hover & {
      @apply text-brand-primary-darkest;
    }
    .sub-menu--display & {
      @apply underline lg:no-underline;
    }

    svg {
      .menu__item:hover & {
        @apply fill-brand-primary-darkest;
      }
    }
  }
  &__items {
    @apply min-w-[18rem] hidden lg:flex opacity-0 scale-0 style-body-bold lg:style-body lg:delay-200 ease-in-out normal-case lg:bg-neutral-white lg:rounded-sm lg:border-hairline border-neutral-light py-xxxs lg:py-0 px-xxs sm:pr-md lg:px-0 flex-col gap-xxxs lg:gap-0 lg:absolute lg:shadow-2xl w-full lg:w-max top-[5.5rem] transition-opacity duration-300;

    .sub-menu--display & {
      @apply flex lg:hidden opacity-100 scale-100;
    }
    .menu__item:hover & {
      @apply lg:block lg:opacity-100 lg:scale-100;
    }
  }
  &__item {
    @apply flex justify-between gap-xxxs lg:hover:bg-neutral-lightest lg:px-xxs lg:py-xxxs;

    &:first-of-type {
      @apply rounded-t-s;
    }
    &:last-of-type {
      @apply rounded-b-s;
    }
    &:not(:hover) {
      transition: padding-left 0.5s ease;
    }
    &:hover {
      @apply text-brand-primary-darkest lg:bg-brand-primary-lightest lg:pl-md;

      &:before {
        @apply absolute left-xxxs lg:content-['\2192'];
      }
    }
  }
  &__link {
    @apply flex justify-between w-full lg:w-fit;
  }
  &__icon {
    @apply lg:hidden;
  }
}
</style>
